<template>
  <div
    class="panel-loading"
    role="status"
  >
    <FAIcon
      icon="circle-notch"
      spin
      size="2x"
    />
    <span class="loading-text">{{ $t('general.loading') }}</span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
/* a view waiting for its first data; laid out like EmptyState */
.panel-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75em;
  box-sizing: border-box;
  height: 100%;
  padding: 2em 1em;
  color: var(--textFaint, var(--text));
}
</style>
